import React from 'react';
import { useFetchAuditStructureQuery, useFetchDomainAuditQuery } from './service';
import LoaderCard from '../shared/LoaderCard';
import AuditReport from './AuditReport';
import { Alert } from 'antd';

type Props = {
    websiteGuid: string;
};

export default function DomainAuditReport({ websiteGuid }: Props) {
    const { data: domainAudit, isLoading: isLoadingDomainAudit, isError: isAuditError } = useFetchDomainAuditQuery({ w_guid: websiteGuid });
    const { data: auditStructure, isLoading: isLoadingAuditStructure, isError: isAuditStructureFetchingError } = useFetchAuditStructureQuery();

    const isLoading = isLoadingDomainAudit || isLoadingAuditStructure;
    const isReportNotFound = !isLoading && isAuditError;
    const isAuditStructureError = !isLoading && isAuditStructureFetchingError;
    const isSuccess = !isLoading && domainAudit && auditStructure;

    return (
        <>
            {isLoading && <LoaderCard description="Loading report..." />}
            {isReportNotFound && (
                <Alert
                    message="An error has occurred"
                    description="No report found"
                    type="error"
                    showIcon
                />
            )}
            {isAuditStructureError && (
                <Alert
                    message="An error has occurred"
                    description="Please try again"
                    type="error"
                    showIcon
                />
            )}
            {isSuccess && (
                <AuditReport
                    seoAudit={domainAudit}
                    seoAuditStructure={auditStructure}
                />
            )}
        </>
    );
}
